import axiosInstance from "./axiosInstance";

// Get all transactions
export const fetchTransaction = async () => {
    const response = await axiosInstance.get("/transaction/getall");
    return response.data;
};

export const fetchTransactionByUser = async (data) => {
    const response = await axiosInstance.get("/transaction/getbyuser", {
        params: data
      });
    return response.data;
};

// Create a new transaction
export const createTransaction = async (data) => {
    const response = await axiosInstance.post("/transaction", data);
    return response.data;
};

// Update a transaction
export const updateTransaction = async ({ id, data }) => {
    const response = await axiosInstance.put(`/transaction/${id}`, data);
    return response.data;
};

// Delete a transaction
export const deleteTransaction = async (data) => {
    await axiosInstance.delete(`/transaction`, {
        params: data
    });
};


export const buyPackage = async (data) => {
    const response = await axiosInstance.post("/transaction/buypackage", data);
    return response.data;
};

export const buyCourse = async (data) => {
    const response = await axiosInstance.post("/transaction/buycourse", data);
    return response.data;
};